<template>
  <div class="home--type6">
    <Header v-if="isPage" />

    <div class="search-hero">
      <p class="search-label"
         v-if="isPage">
        {{ title2 }}
      </p>

      <el-input class="search-input--image"
                clearable
                v-model="state.searchValue"
                prefix-icon="el-icon-search"
                placeholder="Search a fit..."
                autocomplete="off"
                @clear="handleSearch"
                @keyup.enter.native="handleSearch">
        <template #append>
          <!-- 图片搜索按钮 -->
          <ImageSearchBtn :isSuit="true" />
        </template>
      </el-input>
    </div>

    <!-- 卡片列表 -->
    <div class="cards-container">
      <p class="grid-label"
         id="gridLabel">
        {{ title3 }}
      </p>

      <!-- 卡片列表内容 -->
      <CardList :loading="loading"
                :listData="listData" />
    </div>

    <p class="scroll-tip"
       v-if="loading">
      Loading...
    </p>

    <p class="scroll-tip"
       v-if="noMore">
      Loading finish
    </p>

    <RightFixedPanel v-if="!isPage" />

    <!-- 页尾 -->
    <Footer v-if="isPage" />
  </div>
</template>

<script>
import CardList from "./components/card.vue"
import Header from "./components/header.vue"
import Footer from "./components/footer.vue"
import ImageSearchBtn from '@/components/ImageSearchBtn.vue'
import productApi from '@/api/product'
import RightFixedPanel from '@/components/RightFixedPanel.vue'

export default {
  name: "IndexPage",

  components: {
    Header,
    Footer,
    CardList,
    ImageSearchBtn,
    RightFixedPanel
  },

  props: {
    isPage: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      title2: '',
      title3: '',
      state: {
        searchValue: ''
      },
      loading: false,
      // 分页参数
      pageNum: 1,
      pageSize: 10,
      // 列表数据
      listData: [],
      total: 0
    }
  },

  computed: {
    noMore() {
      return !this.loading && this.listData.length >= this.total
    },

    disabled() {
      return this.loading || this.noMore
    }
  },

  created() {
    this.loadData()
    const homeData = JSON.parse(sessionStorage.getItem('homeData'))
    this.title2 = homeData.homeContent.title2
    this.title3 = homeData.homeContent.title3
  },

  mounted() {
    // 添加 window 滚动监听
    window.addEventListener('scroll', this.handleScroll)
  },

  beforeDestroy() {
    // 移除 window 滚动监听
    window.removeEventListener('scroll', this.handleScroll)
  },

  methods: {
    handleSearch() {
      this.pageNum = 1
      this.loadData()
    },

    /**
     * 处理 window 滚动事件
     * 当滚动到页面底部时加载更多数据
     */
    handleScroll() {
      // 滚动高度 + 可视区域高度 >= 文档总高度 - 阈值时触发加载
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const windowHeight = window.innerHeight || document.documentElement.clientHeight
      const documentHeight = document.documentElement.scrollHeight
      const threshold = 100 // 距离底部100px时开始加载

      if (scrollTop + windowHeight >= documentHeight - threshold) {
        this.load()
      }
    },

    // 加载数据
    async loadData() {
      try {
        this.loading = true
        const params = {
          title: this.state.searchValue,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }

        const res = await productApi.getGoodsSuitList(params)

        if (res.code === 200 && res.rows) {
          // 如果是第一页，直接赋值；否则追加数据
          if (this.pageNum === 1) {
            this.listData = res.rows
          } else {
            this.listData = [...this.listData, ...res.rows]
          }
          this.total = res.total
        }
      } catch (error) {
        console.error('获取商品套装列表失败:', error)
      } finally {
        this.loading = false
      }
    },

    // 滚动加载更多
    load() {
      // 正在加载或没有更多数据时，不触发新的请求
      if (this.loading || this.noMore) return
      this.pageNum++
      this.loadData()
    }
  }

}
</script>

<style scoped lang="scss">
.home--type6 {
  flex: auto;
  display: flex;
  flex-direction: column;
  background-color: var(--background-color);
  box-sizing: border-box;
}

.search-hero {
  width: 100%;
  max-width: 560px;
  padding: 0 20px;
  margin: 0 auto;

  .search-label {
    font-weight: 600;
    color: hsl(from var(--primary-color) h s l / 0.4);
    font-size: 12px;
    letter-spacing: .06em;
    text-transform: uppercase;
    margin-bottom: 14px;
  }

  :deep(.el-input__inner::placeholder) {
    color: hsl(from var(--primary-color) h s l / 0.4);
    font-size: 12px;
  }
}

.cards-container {
  flex: auto;
  width: 100%;
  max-width: 560px;
  margin: 0 auto;
  padding: 0 20px;

  .grid-label {
    margin-top: 20px;
    color: hsl(from var(--primary-color) h s l / 0.4);
    font-size: 10px;
    letter-spacing: .16em;
    text-transform: uppercase;
    font-weight: 500;
    margin-bottom: 14px;
  }
}

.scroll-tip {
  padding: 40px 0;
  margin: 0;
  text-align: center;
  font-size: 14px;
  color: hsl(from var(--primary-color) h s l / 0.4);
}

// @media(max-width: 450px) {
//   .cards-container {
//     padding: 0 16px;
//   }
//   .search-hero {
//     padding: 0 16px;
//   }
// }
</style>